import React from 'react';
import {strokeWidthOfLine} from './generateStyle';
import { getBezierPath } from 'react-flow-renderer';

const connnectionLineComponent = ({sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition, connectionLineType, connectionLineStyle}) => {
  const edgePath = getBezierPath({
      sourceX,
      sourceY,
      sourcePosition,
      targetX,
      targetY,
      targetPosition,
  });

  return (
    <g>
      <path fill="none" stroke="#222" strokeWidth={3} className="animated" d={edgePath} />
      <circle cx={targetX} cy={targetY} fill="#fff" r={3} stroke="#222" strokeWidth={strokeWidthOfLine} />
    </g>
  );
};

export default connnectionLineComponent;